import React, { useState } from 'react'
import { Box, Button } from '@mui/material';
import CautionImg from '../assets/caution_img.svg'
import ImageViewer from './imageViewer';

const AdditionalInfo = ({ bookingDetails, currentActivity, parkingName, otp }) => {
    const [isImageViewerOpen, setIsImageViewerOpen] = useState(false)
    const imageUrls = Array.isArray(bookingDetails?.imageUrls) ? bookingDetails.imageUrls : []
    const hasImages = imageUrls.length > 0

    const ArrivalInfo = () => {
        return (
            <>
                <Box sx={{ marginBottom: "15px", display: "flex", justifyContent: "flex-start", alignItems: "center", backgroundColor: "#FFFEE7", width: "100%", padding: "8px 8px", borderRadius: "4px" }}>
                    <img src={CautionImg} alt='Caution' width={13} height={13} />
                    <Box sx={{ color: theme => theme.palette.darkBrown.main, fontSize: "12px", fontWeight: theme => theme.typography.fontWeightSemibold, marginLeft: "10px" }}>{`Our valet is ready for you. Please head to the ${parkingName} valet booth.`}</Box>
                </Box>
            </>
        )
    }

    const OTP = () => {
        if(!otp) return null
        else if(currentActivity.event === 'Handed Over') return null
        return (
            <>
                    <Box sx={{ marginBottom: "15px", padding: "16px", border: "1px solid #EEEEEE", width: "100%", borderRadius: "4px" }}>
                        <Box sx={{ color: theme => theme.palette.darkBrown.main, fontSize: "12px", fontWeight: theme => theme.typography.fontWeightSemibold, marginBottom: "8px" }}>Share this OTP with the Operator.</Box>
                        <Box sx={{ color: "#18CC69", fontSize: "28px", fontWeight: theme => theme.typography.fontWeightSemibold, letterSpacing: "0.16px" }}>{otp}</Box>
                    </Box>
            </>
        )
    }

    return <>
        {currentActivity.event === 'Arrived' && <ArrivalInfo/>}
            <OTP/>
            <Box sx={{ marginBottom: "15px" }}>
                <Button
                    disableRipple
                    disabled={!hasImages}
                    onClick={() => setIsImageViewerOpen(true)}
                    sx={{
                        padding: 0,
                        minWidth: "auto",
                        textTransform: "none",
                        color: hasImages ? "#1976d2" : "#BDBDBD",
                        fontSize: "14px",
                        fontWeight: theme => theme.typography.fontWeightSemibold,
                        "&.Mui-disabled": {
                            color: "#BDBDBD",
                        }
                    }}
                >
                    {hasImages ? "View Images" : "No Images"}
                </Button>
            </Box>
            <ImageViewer
                imageUrls={imageUrls}
                open={isImageViewerOpen}
                onClose={() => setIsImageViewerOpen(false)}
            />
    </>
}

export default AdditionalInfo
